const AppError = ({ noText = false, error, labels }) => {
  return (
    <div className="error-page">
      <div className="error-page__logo" />
      {error?.status && error.status === 403 ? (
        <div className="error-page__content">
          <h1>
            {labels?.WELFARE_UNAUTHORIZED_MESSAGE ||
              "Sorry, but you don't have the permissions to see this page."}
          </h1>
          <a href="/" target="_blank" rel="noreferrer" className="link--text">
            <span>{labels?.WELFARE_GO_TO_OEL || "Go to One EssilorLuxottica"}</span>
          </a>
        </div>
      ) : noText ? null : (
        <div className="error-page__content">
          <p>{labels?.WELFARE_ERROR_GENERIC || "An unexpected error occurred"}</p>
        </div>
      )}
    </div>
  );
};

export default AppError;
